import { useBillingPricePlansLazyQuery } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

const useAvailablePricePlans = () => {
  const [query, queryResult] = useBillingPricePlansLazyQuery({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (organizationId: string) => {
    const result = await query({
      variables: {
        organizationId,
        usersOnly: true,
      },
    });

    return result;
  };

  const pricePlan = queryResult.data?.organizationPricePlansCanMigrateToQuery;

  return {
    request,
    error: queryResult.error,
    loading: queryResult.loading,
    data: {
      pricePlan,
    },
  };
};

export default useAvailablePricePlans;
